// extracted by mini-css-extract-plugin
export default {"container":"TakeLivePoll_container__7SHmq","innerContainer":"TakeLivePoll_innerContainer__gLu1L","companyLogoAndBrand":"TakeLivePoll_companyLogoAndBrand__GbclO"};